module.exports = __webpack_public_path__ + "static/media/serenedry-logo.257692ae.png";